import PurchaseList from "./PurchaseList";
import PurchaseShow from "./PurchaseShow";
import PurchaseIcon from "@mui/icons-material/ShoppingCart";

const purchases = {
  list: PurchaseList,
  show: PurchaseShow,
  icon: PurchaseIcon,
};

export default purchases;
